import Swiper from 'swiper/bundle';

export default class Sliders {
    constructor() {
        
        this.init();
    }

    init() {

        // === SWIPER HERO HOME ===
        const swiperHeroHome = document.querySelector('.swiper-hero-home');

        if( swiperHeroHome ) {
            const swiperHeroHomeSwiper = new Swiper(".swiper-hero-home", {
                loop: true,
                grabCursor: true,
                effect: "creative",
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: ["-20%", 0, -1],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                pagination: {
                    el: ".swiper-hero-home .swiper-pagination",
                    clickable: true,
                },
            });
        }

        // === SWIPER JOBS ===
        const swiperJobs = document.querySelector('.swiper-jobs');

        if( swiperJobs ) {
            const swiperJobsSwiper = new Swiper(".swiper-jobs", {
                slidesPerView: 1.25,
                spaceBetween: 14,
                grabCursor: true,
                breakpoints: {
                    768: {
                        slidesPerView: 2.25,
                    },
                    1200: {
                        slidesPerView: 4.25,
                    },
                },
            });
        }

    }
}